import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { IssueTrackingTool } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("IST_MODULE");

export const moduleActions = createDataModuleActions<IssueTrackingTool>(actionCreator);
export const getIstTableActions = createTableActionsGetter(normalizeActions(moduleActions.table));
export const itsActions = {
  ...normalizeActions(moduleActions.data),
};
export const itsActionCreators = {
  ...moduleActions,
};
